/* global gdAlertify */
import React, { useEffect, useState } from "react";
import axiosInstance from "../../config/axiosConfig";
import { BadgeEstado, IconoCanal, fechaHora, mensajeError } from "./enviosUi";
import { urlImagenMensaje } from "./honorariosWsp";

const ORIGEN_EVENTO = {
    sistema: "Sistema",
    worker: "Motor",
    webhook: "Proveedor",
    cron: "Consulta automática",
    usuario: "Usuario",
};

const DescripcionAdjunto = ({ adjunto }) => {
    const nombre = adjunto.nombre || "adjunto";
    switch (adjunto.tipo) {
        case "s3": return <>{nombre} <small className="text-muted">(archivo en S3, se descarga al enviar)</small></>;
        case "link": return <>{nombre} <small className="text-muted">({adjunto.url})</small></>;
        case "ycloud_media": return <>{nombre} <small className="text-muted">(subido a YCloud)</small></>;
        case "generado": return <>{nombre} <small className="text-muted">(se genera en el servidor al enviar)</small></>;
        default: return nombre;
    }
};

const EnvioMensajeModal = ({ mensajeId, onClose, onCambio }) => {
    const [datos, setDatos] = useState(null);
    const [loading, setLoading] = useState(true);

    const cargar = async () => {
        setLoading(true);
        try {
            const { data } = await axiosInstance.get(`/envios/mensajes/${mensajeId}`);
            setDatos(data?.data || null);
        } catch (error) {
            gdAlertify.notiError(mensajeError(error, "No se pudo cargar el mensaje."));
            onClose();
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        cargar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mensajeId]);

    const reintentar = async () => {
        gdAlertify.showLoader();
        try {
            await axiosInstance.post(`/envios/mensajes/${mensajeId}/reintentar`);
            gdAlertify.notiSuccess("Mensaje reencolado: sale en el próximo ciclo.");
            onCambio?.();
            cargar();
        } catch (error) {
            gdAlertify.notiError(mensajeError(error, "No se pudo reintentar."));
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const [imagen, setImagen] = useState({ cargando: false, url: null });
    useEffect(() => () => { if (imagen.url) URL.revokeObjectURL(imagen.url); }, [imagen.url]);

    const verImagen = async () => {
        setImagen({ cargando: true, url: null });
        try {
            setImagen({ cargando: false, url: await urlImagenMensaje(mensajeId) });
        } catch (error) {
            setImagen({ cargando: false, url: null });
            gdAlertify.notiError(error.message);
        }
    };

    const consultarYCloud = async () => {
        gdAlertify.showLoader();
        try {
            const { data } = await axiosInstance.post(`/envios/mensajes/${mensajeId}/consultar`);
            const r = data?.data || {};
            if (r.estado === "fallido") gdAlertify.notiError(`YCloud: falló. ${r.error_detalle || ""}`);
            else gdAlertify.notiSuccess(`Estado en YCloud: ${r.ycloud_status || r.estado}`);
            onCambio?.();
            cargar();
        } catch (error) {
            gdAlertify.notiError(mensajeError(error, "No se pudo consultar YCloud."));
        } finally {
            gdAlertify.hideLoader();
        }
    };

    const m = datos?.mensaje;
    const eventos = datos?.eventos || [];
    const parametros = m?.parametros_json || {};
    // El adjunto generado puede ser la imagen de honorarios o el PDF del detalle de cobranza.
    const esPdf = (m?.adjuntos_json || []).some((a) => a.tipo === "generado" && a.mime === "application/pdf");

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)", overflowY: "auto" }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header bg-dark text-white">
                        <h5 className="modal-title">
                            {m && <IconoCanal tipo={m.canal_tipo} />} <span className="ms-2">Mensaje #{mensajeId}</span>
                        </h5>
                        <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>

                    <div className="modal-body">
                        {loading || !m ? (
                            <div className="text-center py-4"><div className="spinner-border text-primary" role="status"></div></div>
                        ) : (
                            <div className="row g-4">
                                <div className="col-lg-7">
                                    <dl className="row mb-3">
                                        <dt className="col-sm-4">Destinatario</dt>
                                        <dd className="col-sm-8">{m.destinatario}{m.destinatario_nombre && ` (${m.destinatario_nombre})`}</dd>
                                        {m.cc && (<><dt className="col-sm-4">CC</dt><dd className="col-sm-8">{m.cc}</dd></>)}
                                        <dt className="col-sm-4">Canal</dt>
                                        <dd className="col-sm-8">{m.canal_nombre}</dd>
                                        <dt className="col-sm-4">Estado</dt>
                                        <dd className="col-sm-8"><BadgeEstado estado={m.estado} /> <small className="text-muted ms-2">{m.intentos} intento(s)</small></dd>
                                        {m.error_detalle && (
                                            <>
                                                <dt className="col-sm-4">Último error</dt>
                                                <dd className="col-sm-8 text-danger"><small>[{m.error_codigo}] {m.error_detalle}</small></dd>
                                            </>
                                        )}
                                        {m.entidad_tipo && (
                                            <>
                                                <dt className="col-sm-4">Asociado a</dt>
                                                <dd className="col-sm-8">{m.entidad_tipo} #{m.entidad_id}</dd>
                                            </>
                                        )}
                                        <dt className="col-sm-4">ID proveedor</dt>
                                        <dd className="col-sm-8"><small className="text-muted">{m.proveedor_id || "—"}</small></dd>
                                    </dl>

                                    {m.canal_tipo === "email" ? (
                                        <>
                                            <h6 className="fw-semibold">Asunto: {m.asunto}</h6>
                                            <iframe title="Contenido del correo" srcDoc={m.cuerpo_html || ""} sandbox=""
                                                className="w-100 border rounded" style={{ height: 380, background: "#fff" }} />
                                        </>
                                    ) : m.plantilla ? (
                                        <div className="border rounded p-3 bg-light">
                                            <div className="mb-2"><strong>Plantilla:</strong> {m.plantilla} <small className="text-muted">({m.plantilla_idioma || "idioma por defecto"})</small></div>
                                            {(parametros.body || []).length > 0 && (
                                                <ol className="mb-0">
                                                    {parametros.body.map((v, i) => (
                                                        // Numeradas: texto. Con nombre: { nombre, valor }.
                                                        <li key={i}>
                                                            <code>{`{{${typeof v === "object" ? v.nombre : i + 1}}}`}</code> = {typeof v === "object" ? v.valor : v}
                                                        </li>
                                                    ))}
                                                </ol>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="border rounded p-3 bg-light" style={{ whiteSpace: "pre-wrap" }}>{m.cuerpo_texto}</div>
                                    )}

                                    {(m.adjuntos_json || []).length > 0 && (
                                        <div className="mt-3">
                                            <h6 className="fw-semibold">Adjuntos</h6>
                                            <ul className="mb-0">
                                                {m.adjuntos_json.map((a, i) => <li key={i}><DescripcionAdjunto adjunto={a} /></li>)}
                                            </ul>
                                            {m.adjuntos_json.some((a) => a.tipo === "generado") && (
                                                <div className="mt-2">
                                                    {!imagen.url && (
                                                        <button className="btn btn-sm btn-outline-primary" onClick={verImagen} disabled={imagen.cargando}>
                                                            {imagen.cargando ? <span className="spinner-border spinner-border-sm me-1"></span> : <i className={`bi ${esPdf ? "bi-file-earmark-pdf" : "bi-image"} me-1`}></i>}
                                                            {esPdf ? "Ver PDF" : "Ver imagen"}
                                                        </button>
                                                    )}
                                                    {imagen.url && esPdf && (
                                                        <iframe title="PDF del mensaje" src={imagen.url} className="border rounded" style={{ width: "100%", height: "60vh" }} />
                                                    )}
                                                    {imagen.url && !esPdf && (
                                                        <a href={imagen.url} target="_blank" rel="noreferrer">
                                                            <img src={imagen.url} alt="Imagen del mensaje" className="img-fluid border rounded" />
                                                        </a>
                                                    )}
                                                    <div className="form-text">
                                                        {["enviado", "entregado", "leido"].includes(m.estado)
                                                            ? "Copia guardada al enviar (S3)."
                                                            : "Aún no se envía: se genera al momento con los datos actuales."}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="col-lg-5">
                                    <h6 className="fw-semibold mb-3">Historial</h6>
                                    <ul className="list-unstyled border-start ps-3 mb-0">
                                        {eventos.map((e) => (
                                            <li key={e.id} className="mb-3">
                                                <div className="d-flex align-items-center gap-2">
                                                    <BadgeEstado estado={e.estado_nuevo} />
                                                    <small className="text-muted">{fechaHora(e.created_at)}</small>
                                                </div>
                                                <small className="text-muted">
                                                    {ORIGEN_EVENTO[e.origen] || e.origen}
                                                    {e.usuario_nombre && ` · ${e.usuario_nombre}`}
                                                </small>
                                                {e.detalle_json && (
                                                    <pre className="small bg-light border rounded p-2 mt-1 mb-0" style={{ whiteSpace: "pre-wrap" }}>
                                                        {JSON.stringify(typeof e.detalle_json === "string" ? JSON.parse(e.detalle_json) : e.detalle_json, null, 2)}
                                                    </pre>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        {m && m.canal_tipo === "whatsapp" && m.proveedor_id && (
                            <button className="btn btn-outline-success me-auto" onClick={consultarYCloud}
                                title="Trae el estado real desde YCloud (útil si el webhook no llega)">
                                <i className="bi bi-cloud-check me-1"></i>Consultar estado en YCloud
                            </button>
                        )}
                        {m && ["fallido", "cancelado"].includes(m.estado) && (
                            <button className="btn btn-warning" onClick={reintentar}>
                                <i className="bi bi-arrow-counterclockwise me-1"></i>Reintentar
                            </button>
                        )}
                        <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnvioMensajeModal;
